import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'loading-page',
  templateUrl: './loading-custom.component.html',
  styleUrls: ['./loading-custom.component.scss']
})
export class LoadingCustomComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
